import type {
  CommunicationCalendarItemDTO,
  CommunicationHubResponseDTO,
  CommunicationMeetingDetailDTO,
  CommunicationMeetingItemDTO,
  CommunicationMeetingListQueryDTO,
  CommunicationMinuteDetailDTO,
  CommunicationMinuteItemDTO,
  CommunicationNotificationItemDTO,
} from "@/modules/communication/domain/contracts";
import { config } from "@/shared/lib/config";
import { fetcher } from "@/shared/lib/fetcher";

const base = () => `${config.apiUrl}/communication`;

export const communicationApi = {
  hub(): Promise<CommunicationHubResponseDTO> {
    return fetcher.get(`${base()}/hub`);
  },
  meetings(query: Partial<CommunicationMeetingListQueryDTO>): Promise<{
    data: CommunicationMeetingItemDTO[];
    meta: { total: number; limit: number; offset: number };
  }> {
    const url = new URL(`${base()}/meetings`);
    if (query.fromDate) url.searchParams.set("fromDate", query.fromDate);
    if (query.toDate) url.searchParams.set("toDate", query.toDate);
    if (query.search) url.searchParams.set("search", query.search);
    url.searchParams.set("limit", String(query.limit ?? 20));
    url.searchParams.set("offset", String(query.offset ?? 0));
    return fetcher.get(url.toString());
  },
  meetingById(id: string): Promise<CommunicationMeetingDetailDTO> {
    return fetcher.get(`${base()}/meetings/${id}`);
  },
  minutes(search?: string): Promise<{
    data: CommunicationMinuteItemDTO[];
    meta: { total: number; limit: number; offset: number };
  }> {
    const url = new URL(`${base()}/minutes`);
    if (search) url.searchParams.set("search", search);
    return fetcher.get(url.toString());
  },
  minuteById(id: string): Promise<CommunicationMinuteDetailDTO> {
    return fetcher.get(`${base()}/minutes/${id}`);
  },
  calendar(query?: { fromDate?: string; toDate?: string }): Promise<{
    data: CommunicationCalendarItemDTO[];
    meta: { total: number; limit: number; offset: number };
  }> {
    const url = new URL(`${base()}/calendar`);
    if (query?.fromDate) url.searchParams.set("fromDate", query.fromDate);
    if (query?.toDate) url.searchParams.set("toDate", query.toDate);
    return fetcher.get(url.toString());
  },
  notifications(): Promise<{
    data: CommunicationNotificationItemDTO[];
    meta: { total: number; limit: number; offset: number };
  }> {
    return fetcher.get(`${base()}/notifications`);
  },
  markNotificationRead(id: string): Promise<{ ok: boolean }> {
    return fetcher.patch(`${base()}/notifications/${id}/read`, {});
  },
};
